import React from 'react';
import { RECONOCIMIENTO_DATA } from '@/data/mock';
import { SolutionPageLayout } from '@/components/shared/SharedComponents';
import {
  Award, Shield, Coins, Gift, Gamepad2, BarChart3,
  Building2, Factory, Landmark
} from 'lucide-react';

const featureIcons = { Award, Shield, Coins, Gift, Gamepad2, BarChart3 };
const audienceIcons = { Building2, Factory, Landmark };

export default function ReconocimientoPage() {
  return (
    <SolutionPageLayout
      heroData={RECONOCIMIENTO_DATA.hero}
      features={RECONOCIMIENTO_DATA.features}
      stats={RECONOCIMIENTO_DATA.stats}
      audiences={RECONOCIMIENTO_DATA.audiences}
      featureIcons={featureIcons}
      audienceIcons={audienceIcons}
    />
  );
}
